<template>
  <div>
    <!-- ✅ PUBLICAR -->
    <c-q-btn
      v-if="showPublishButton"
      id="btn-publish-institutional"
      propBtnLabel="Publicar Cadastro"
      :propBtnFunction="onPublishInstitutional"
      :propBtnTransparent="false"
      :propBtnSize="EnumButtonSizes.LARGE_1"
    />

    <!-- ✅ REPUBLICAR -->
    <c-q-btn
      v-if="showRepublishButton"
      id="btn-republish-institutional"
      propBtnLabel="Republicar Cadastro"
      :propBtnFunction="onRepublishInstitutional"
      :propBtnTransparent="false"
      :propBtnSize="EnumButtonSizes.LARGE_1"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { EnumButtonSizes } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'

import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'

import messages from '@/utils/messages'

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()

/**
 * ✅ SHOW PUBLICAR
 */
const showPublishButton = computed(() => {
  return (
    authStore.currentUserCanCreateInstitutional &&
    institutionalStore.institutionalDetail?.status ===
      CONST_INSTITUTIONAL_STATUS.APPROVED.id
  )
})

/**
 * ✅ SHOW REPUBLICAR
 */
const showRepublishButton = computed(() => {
  return (
    authStore.currentUserCanCreateInstitutional &&
    institutionalStore.institutionalDetail?.status ===
      CONST_INSTITUTIONAL_STATUS.REAPPROVED.id
  )
})

/**
 * ✅ PUBLICAR
 */
const onPublishInstitutional = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.publishInstitutional(id)

    messages.showSuccessMsg('Cadastro publicado com sucesso!')

  } catch (error) {
    console.error(error)
    messages.showErrorMsg('Erro ao publicar cadastro.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}

/**
 * ✅ REPUBLICAR
 */
const onRepublishInstitutional = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.republishInstitutional(id)

    messages.showSuccessMsg('Cadastro republicado com sucesso!')

  } catch (error) {
    console.error(error)
    messages.showErrorMsg('Erro ao republicar cadastro.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}
</script>

<style scoped>
</style>